'use client';

import ArrowRec from '@alltrails/denali/icons/ArrowRec';
import IconButton from '@alltrails/denali/components/IconButton';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import { Typography, Image } from '@alltrails/core';
import { StaticImageData } from 'next/image';
import classNames from 'classnames';
import type { ComponentProps, JSX } from 'react';
import styles from './styles/styles.module.scss';

type HeroImageProps = {
  alt: string;
  headerText: string;
  headerSubText: string;
  linkInfo?: ComponentProps<typeof IconButton>['linkInfo'];
  onArrowClick?: () => void;
  imageData: { mobileSrc: StaticImageData; src: StaticImageData };
  textContainerStyles?: string;
  quality?: number;
  ariaLabel?: string;
};

const HeroImage = ({
  alt,
  onArrowClick,
  headerText,
  headerSubText,
  linkInfo,
  imageData,
  textContainerStyles,
  quality,
  ariaLabel
}: HeroImageProps): JSX.Element => {
  const isMobile = useIsMobileSizedScreen();
  const { src, mobileSrc } = imageData;
  return (
    <div className={styles.container}>
      <Image src={isMobile ? mobileSrc : src} alt={alt} className={styles.hero} priority fill quality={quality} />
      <div className={classNames(styles.innerContainer, textContainerStyles)}>
        <Typography component="h1" variant="heading300" color="inverse" mb="16">
          {headerText}
        </Typography>
        <Typography variant="heading700" mb="16" color="inverse" className={styles.headerSubtext} component="h2">
          {headerSubText}
        </Typography>
      </div>
      <div className={styles.largeArrow}>
        <IconButton
          icon={{ Component: ArrowRec, orientation: 'down' }}
          linkInfo={linkInfo}
          onClick={onArrowClick}
          testId="hero-image-down-arrow"
          ariaLabel={ariaLabel}
          title={alt}
          size="lg"
          variant="transparent"
        />
      </div>
    </div>
  );
};

export default HeroImage;
